import {useState, useEffect} from 'react';
import {toast} from 'react-toastify';
import {ErrorMessage} from '@hookform/error-message';
import {useForm, Controller} from 'react-hook-form';
import FormInput from '../../components/FoodMenu/FormInput';
import {
    updateDeliverySettings,
    getDeliverySettings,
} from '../../../services/SettingsService';
import TimePicker from '../../components/Settings/TimePicker';
import {objectToFormData} from '../../../utils/objectToFormData';
const notify = (id, type, message, time) => {
    toast.update(id, {
        render: message,
        type: type,
        position: 'top-center',
        autoClose: time,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        isLoading: false,
    });
};
const DeliverySettings = () => {
    const [deldetails, setDeldetails] = useState();
    const {
        handleSubmit,
        formState: {errors},
        register,
        setValue,
        control,
    } = useForm({
        mode: 'all',
        defaultValues: {
            slot_start_time:
                new Date('2000-01-01 10:00 AM').getHours() +
                ':' +
                String(new Date('2000-01-01 10:00 AM').getMinutes()).padStart(
                    2,
                    '0'
                ),
            slot_end_time:
                new Date('2000-01-01 11:00 PM').getHours() +
                ':' +
                String(new Date('2000-01-01 11:00 PM').getMinutes()).padStart(
                    2,
                    '0'
                ),
        },
    });
    useEffect(() => {
        getDeliverySettings().then(res => setDeldetails(res[0]));
    }, []);

    const days = [
        {
            name: 'delivery_days.sun',
            label: 'Sunday',
        },
        {
            name: 'delivery_days.mon',
            label: 'Monday',
        },
        {
            name: 'delivery_days.tue',
            label: 'Tuesday',
        },
        {
            name: 'delivery_days.wed',
            label: 'wednesday',
        },
        {
            name: 'delivery_days.thu',
            label: 'Thursday',
        },
        {
            name: 'delivery_days.fri',
            label: 'Friday',
        },
        {
            name: 'delivery_days.sat',
            label: 'Saturday',
        },
    ];

    useEffect(() => {
        if (deldetails) {
            const fields = [
                'is_delivery',
                'delivery_time',
                'delivery_prior_time',
                'delivery_charge',
                'delivery_days',
                'slot_duration',
                'is_free_delivery',
                'slot_start_time',
                'slot_end_time',
                'delivery_booking_charge',
            ];

            fields.forEach(field => setValue(field, deldetails[field]));
        }
    }, [setValue, deldetails]);

    const onSubmit = async data => {
        const toaster = toast.loading('Updating...');

        let postData = objectToFormData(data);
        let res = await updateDeliverySettings(postData);

        if (res && res.status === 'success') {
            notify(toaster, 'success', 'Updated Delivery Settings!', 2000);
        } else {
            notify(
                toaster,
                'error',
                'Failed to update delivery settings',
                2000
            );
        }
    };

    return (
        <>
            <div className='modal-body'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='d-flex row'>
                        <div className='col-md-6 col-xl-3 col-xxl-6 mb-3 picker-data'>
                            <div className='color-time-picker'>
                                <TimePicker
                                    label={'Start time'}
                                    name={'slot_start_time'}
                                    required={true}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    id={'slot_start_time'}
                                    ErrorMessage={ErrorMessage}
                                    register={{
                                        ...register('slot_start_time'),
                                        required:
                                            'Delivery Start time is required!',
                                    }}
                                />
                            </div>
                        </div>
                        <div className='col-md-6 col-xl-3 col-xxl-6 mb-3 picker-data'>
                            <div className='color-time-picker '>
                                <TimePicker
                                    label={'End time'}
                                    name={'slot_end_time'}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    id={'slot_end_time'}
                                    required={true}
                                    ErrorMessage={ErrorMessage}
                                    register={{
                                        ...register('slot_end_time'),
                                        required:
                                            'Delivery End time is required!',
                                    }}
                                />
                            </div>
                        </div>

                        <div className='col-10'>
                            <FormInput
                                label={'Delivery Prior time (minutes)'}
                                id={'delivery_prior_time'}
                                name={'delivery_prior_time'}
                                required={true}
                                type={'number'}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('delivery_prior_time', {
                                        required:
                                            'Delivery Prior time is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>
                        <div className='col-10'>
                            <FormInput
                                label={'Slot Length  (minutes)'}
                                id={'slot_duration'}
                                name={'slot_duration'}
                                required={true}
                                type={'number'}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('slot_duration', {
                                        required: 'Slot length is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>
                        <div className='col-10'>
                            <FormInput
                                label={'Delivery Charge'}
                                id={'delivery_booking_charge'}
                                name={'delivery_booking_charge'}
                                required={true}
                                type={'number'}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('delivery_booking_charge', {
                                        required:
                                            'Delivery charge is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>

                        <label className='text-black font-w500 col-12'>
                            Delivery days
                        </label>
                        {days.map((day, i) => (
                            <div className='col-4 '>
                                <div className='custom-control custom-checkbox mb-3 checkbox-info'>
                                    <input
                                        type='checkbox'
                                        defaultChecked
                                        className='custom-control-input'
                                        {...register(day.name)}
                                        id={day.name}
                                    />
                                    <label
                                        className='custom-control-label'
                                        htmlFor={day.name}
                                    >
                                        {day.label}
                                    </label>
                                </div>
                            </div>
                        ))}

                        <div className='col-12'>
                            <div className='custom-control custom-checkbox mb-3 '>
                                <input
                                    type='checkbox'
                                    defaultChecked
                                    className='custom-control-input'
                                    {...register('is_free_delivery')}
                                    id='is_free_delivery'
                                />
                                <label
                                    className='custom-control-label'
                                    htmlFor='is_free_delivery'
                                >
                                    Free Delivery
                                </label>
                            </div>
                        </div>
                        <button className='btn btn-primary btn-block btn-md mb-2 mr-auto'>
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};
export default DeliverySettings;
